import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ButtonTable from '../common/table/buttonTable';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';

import { setModoTela, initForm } from './metaBaseSupervisorTrimestreActions';

class MetaBaseSupervisorTrimestreForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='ano'
								component={Select}
								options={[{ id: 2024, valor: 2024 }, { id: 2025, valor: 2025 }, { id: 2026, valor: 2026 }]}
								label='Ano'
								cols='12 4 3 2'
								placeholder='Selecione o ano'
								readOnly={readOnly} />
								
							<Field
								name='trimestre'
								component={Select}
								options={[{ id: 1, valor: '1º trimestre' }, { id: 2, valor: '2º trimestre' }, { id: 3, valor: '3º trimestre' }, { id: 4, valor: '4º trimestre' } ]}
								label='Trimestre'
								cols='12 4 3 2'
								placeholder='Selecione o trimestre'
								readOnly={readOnly} />

							<Field
								name='id_usuario'
								component={Select}
								options={this.props.listaUsuario}
								label='Usuário'
								cols='12 12 6 8'
								placeholder='Selecione o usuário'
								readOnly={readOnly} />

						</Row> 

						<Row>
							<Grid cols='12 12 12 12'>
								<label style={{ fontSize: 18 }}>Indicador I — Visita de Qualidade</label>
							</Grid>
						</Row>

						<Row>
							<Field
								name='visita_qualidade_peso'
								component={LabelAndInputNumber}
								label='Peso (%)' placeholder='Informe'
								cols='12 6 4 3'
								maxWidth={180}
								casas={0}
								readOnly={readOnly} />
						</Row>
						<Row>							
							<Field
								name='visita_qualidade_meta'
								component={LabelAndInputNumber}
								label='Meta de Visitas' placeholder='Informe'
								cols='12 6 4 3'
								maxWidth={180}
								casas={0}
								readOnly={readOnly} />
						</Row>

						<Row>
							<Grid cols='12 12 12 12'>
								<label style={{ fontSize: 18 }}>Indicador II — Ajuste de Estoque</label>
							</Grid>
						</Row>					
						<Row>
							<Field
								name='estoque_peso'
								component={LabelAndInputNumber}
								label='Peso (%)' placeholder='Informe'
								cols='12 6 4 3'
								maxWidth={180}
								casas={0}
								readOnly={readOnly} />
						</Row>
						<Row>	
							<Field
								name='estoque_meta_faixa1'
								component={LabelAndInputNumber}
								label='Meta Faixa 1 (%)' placeholder='Informe'
								title='Percentual de perda'
								cols='12 6 4 3'
								maxWidth={180}
								casas={2}
								readOnly={readOnly} />
							
							<Field
								name='estoque_percentual_faixa1'
								component={LabelAndInputNumber}
								label='Percentual Faixa 1 (%)' placeholder='Informe'
								cols='12 6 4 3'
								maxWidth={180}
								casas={2}
								readOnly={readOnly} />
						</Row>
						<Row>	
							<Field
								name='estoque_meta_faixa2'
								component={LabelAndInputNumber}
								label='Meta Faixa 2 (%)' placeholder='Informe'
								title='Percentual de perda'
								cols='12 6 4 3'
								maxWidth={180}
								casas={2}
								readOnly={readOnly} />
							
							<Field
								name='estoque_percentual_faixa2'
								component={LabelAndInputNumber}
								label='Percentual Faixa 2 (%)' placeholder='Informe'
								cols='12 6 4 3'
								maxWidth={180}
								casas={2}
								readOnly={readOnly} />
						</Row>
						<Row>	
							<Field
								name='estoque_meta_faixa3'
								component={LabelAndInputNumber}
								label='Meta Faixa 3 (%)' placeholder='Informe'
								title='Percentual de perda'
								cols='12 6 4 3'
								maxWidth={180}
								casas={2}
								readOnly={readOnly} />
							
							<Field
								name='estoque_percentual_faixa3'
								component={LabelAndInputNumber}
								label='Percentual Faixa 3 (%)' placeholder='Informe'
								cols='12 6 4 3'
								maxWidth={180}
								casas={2}
								readOnly={readOnly} />
						</Row>
						<Row>	
							<Field
								name='estoque_meta_faixa4'
								component={LabelAndInputNumber}
								label='Meta Faixa 4 (%)' placeholder='Informe'
								title='Percentual de perda'
								cols='12 6 4 3'
								maxWidth={180}
								casas={2}
								readOnly={readOnly} />
							
							<Field
								name='estoque_percentual_faixa4'
								component={LabelAndInputNumber}
								label='Percentual Faixa 4 (%)' placeholder='Informe'
								cols='12 6 4 3'
								maxWidth={180}
								casas={2}
								readOnly={readOnly} />
						</Row>
						<Row>
							<Grid cols='12 12 12 12'>
								<label style={{ fontSize: 18 }}>Indicador III — Performance Operadores de Base</label>
							</Grid>
						</Row>
						<Row>
							<Field
								name='performance_operador_peso'
								component={LabelAndInputNumber}
								label='Peso (%)' placeholder='Informe'
								cols='12 6 4 3'
								maxWidth={180}
								casas={0}
								readOnly={readOnly} />
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }


}

MetaBaseSupervisorTrimestreForm = reduxForm({form: 'metaBaseSupervisorTrimestreForm', destroyOnUnmount: false})(MetaBaseSupervisorTrimestreForm);
const mapStateToProps = state => ({
	sessao: state.auth.metaBaseSupervisorTrimestre,
	formularioValues: getFormValues('metaBaseSupervisorTrimestreForm')(state),
	registro: state.metaBaseSupervisorTrimestre.registro,
	listaUsuario: state.metaBaseSupervisorTrimestre.listaUsuario.filter(item => item.administrador),
	listaVeiculo: state.metaBaseSupervisorTrimestre.listaVeiculo
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaBaseSupervisorTrimestreForm);
